import React from 'react'
import {features} from 'helpers/constants'
import {urls} from 'helpers/url'
import {updateJobBoardFilters} from 'actions/production'
import {t} from "helpers/language"

export const skill = {
  key: "JOB_BOARD",
  group: 'jobboards',
  label: t("Plan and track jobs"),
  desc: t("Use the Job Board to plan and track work required to fulfil your jobs all the way to delivery"),
  feature: features.PRODUCTION_LICENCE,
  steps: [
    {
      content: (
          <div>
            Tell the story of your daily/weekly operations. Plan and track the progress of your jobs.
            The <i>Job Board</i> is an essential tool for a smooth workflow. Identify problems and solve them quickly,
            adding value to your entire production process.<br/>
            <br/>
            Learn about the Job Board now to get started.
          </div>
      ),
      actions: [
        {
          label: 'Let\'s Go',
          primary: true,
          type: 'next',
        },
        {
          label: 'Not Now',
          flat: true,
          type: 'close',
        },
      ],
    },
    {
      target: '.settings-production-scene-jobBoardSetup',
      location: urls.settings.setupDepartmentsAndWorkCentres,
      placement: 'bottom',
    },
    {
      target: '.jobBoard-lane-container-first .jobBoard-lane-header',
      location: urls.jobBoards.jobBoardView,
      action: () => updateJobBoardFilters({
        statuses: [],
        departments: [],
        search: null,
        targetStart: null,
        targetEnd: null,
        timeKey: null,
      }),
      placement: 'right',
      content: (
        <div>
          This is the <i>Order Book</i>. Here you will find all your confirmed jobs, with those required sooner at the top of the list.<br/>
          <br/>
          If you have no confirmed jobs, confirm a job now and then return to this skill by hitting <i>F1</i> and selecting <i>Job Boards</i>.
        </div>
      ),
      actions: [
        {
          label: "Confirm a Job",
          flat: true,
          primary: false,
          type: 'skill',
          skill: 'RAISE_QUOTE',
        },
        {
          label: "Next",
          flat: true,
          primary: true,
          type: 'next',
        },
      ],
    },
    {
      target: '.jobBoard-lane-container-first .jobCard-container',
      content: <div>To add the job to the job board, click <i>Load Job</i></div>,
    },
    {
      // Inline tooltip in job card setup dialog
      dummy: true,
      isJobCardSetupStep: true,
    },
    {
      target: '.jobBoard-lane-container-department .jobCard-pending',
      placement: 'bottom',
      content: (
        <div>
          Your job card(s) will now show on the board in the first department as Pending (blue).<br/>
          <br/>
          Click <i>Start</i> to start work on this job card.
        </div>
      ),
      isStartJobCardStep: true,
    },
    {
      target: '.jobBoard-lane-container-department .jobCard-wip',
      placement: 'bottom',
      content: (
        <div>
          Job cards which are being currently worked on will show as WIP (orange).<br/>
          <br/>
          When the work has finished, click <i>Complete</i> and the card will automatically move to the next department.
        </div>
      ),
      isCompleteJobCardStep: true,
    },
    {
      target: '.jobBoard-lane-container-last .jobBoard-lane-header',
      placement: 'left',
      content: (
        <div>
          Once work has finished in the last department, it will automatically move to the <i>Goods Out</i> column and
          show as Completed (green).<br/>
          <br/>
          When the job is marked as delivered, the job card will be removed from the Goods Out column.<br/>
          <br/>
          You can also configure the job board to <i>automatically email the customer when production starts and finishes</i>.
        </div>
      ),
      actions: [
        {
          label: "Learn More Skills",
          flat: true,
          type: 'skills',
        },
        {
          label: "Set Up Email Notifications",
          flat: true,
          primary: false,
          type: 'nav',
          location: `${urls.settings.jobBoardsUrl}#WIP_Email_Notifications`,
        },
        {
          label: "Finish",
          flat: true,
          primary: true,
          type: 'finish',
        },
      ],
    },
  ],
}

export default skill
